import { useState, useEffect } from "react"
import config from "react-global-configuration";
import "./index.css"
const HtmlPreview = ({ link }) => {
    const [iframeSrc, setIframeSrc] = useState('')
    const [loading, setLoading] = useState(true)
    const isStandalone = !!window.__COMPANY_DATA__;

    useEffect(() => {
        if (!isStandalone) {
            loadIframe();
        }
    }, [link]);

    const loadIframe = async () => {
        // const host = "www.throbox.com"
        // const origin = "https://www.throbox.com"

        const host = window.location.host;
        const origin = window.location.origin;
        const companyData = {
            ID: config.get('companyID'),
            Email: config.get('SenderEmail'),
            Theme: config.get('Theme'),
            Favicon: config.get('favicon'),
            OrganisationID: config.get('OrganisationID'),
            Logo: config.get('companyLogo'),
            LogoCDN: config.get('companyLogoCDN'),
            Name: config.get('companyPageTitle'),
            LocationID: config.get('LocationID'),
            WorldPayServiceKey: config.get('WorldPayServiceKey'),
            WorldPayClientKey: config.get('WorldPayClientKey'),
            WishListEnabled: config.get('WishListEnabled'),
            HelpPage: config.get('HelpPage'),
            SocialMedia: config.get('SocialMedia'),
            SocialMedias: config.get('SocialMedias'),
            DeliveryMessage: config.get('DeliveryMessage'),
            ShopNowItems: config.get('ShopNowItems'),
            FBappid: config.get('FBappid'),
            FBpageid: config.get('FBpageid'),
            CDNPath: config.get('CDNPath'),
            Style: config.get('Style'),
            OpeningHour: config.get('OpeningHour'),
            SubDomain: host,
            CustomerDomain: origin,
        };

        try {
            const res = await fetch(link);
            console.log(res, "res")
            let html = await res.text();

            const baseUrl = link.substring(0, link.lastIndexOf('/') + 1);

            html = html.replace(
                '<head>',
                `<head>\n<base href="${baseUrl}">`
            );

            html = html.replace(
                '</head>',
                `<style>
        ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
        ::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb:hover {
            background: #555;
        }
            ::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
}

        html, body { 
            scrollbar-width: thin;
            scrollbar-color: #888 transparent;
        }
    </style>
    <script>window.__COMPANY_DATA__ = ${JSON.stringify(companyData)};</script>\n</head>`
            );

            const blob = new Blob([html], { type: 'text/html' });
            const blobUrl = URL.createObjectURL(blob);
            setIframeSrc(blobUrl);
        } catch (e) {
            console.error('Failed to load iframe:', e);
        } finally {
            setLoading(false)
        }
    };
    return (
        <div className="htmlPreview">
            <iframe
                src={iframeSrc}
            />
        </div>
    );
};

export default HtmlPreview;